export default { sha: '97d9f3b85548d35dd3ddf9ea4d90340778960e77', buildNumber: 'undefined' }
